import React, { useState, useEffect } from "react";

import {
Document,
Page,
Text,
View,
Image,
PDFViewer,
StyleSheet,
PDFDownloadLink,
} from '@react-pdf/renderer';

import logoIseP from '../certificados/image.png'
import devolvemeLaEdad from '../tools/devolvemeLaEdad';
import axios from 'axios';
import comprueboPermisos from "../tools/comprueboPermisos";
import ObtieneDatosCookies from "../obtieneDatosCookiesUsuario";

// Estilos

const styles = StyleSheet.create({

page: {
padding: 30,
fontSize: 12,
fontFamily: 'Helvetica',
},

sectionTitle: {
fontSize: 16,
marginBottom: 10,
fontWeight: 'bold',
borderBottom: '1px solid black',
paddingBottom: 5,
},

section: {
marginBottom: 10,
padding: 10,
border: '1px solid #000'
},

fieldGroup: {
marginBottom: 10,
},

fieldRow: {
flexDirection: 'row',
justifyContent: 'space-between',
},

label: {
color: '#444',
},

photo: {
width: 100,
height: 100,
objectFit: 'cover',
position: "absolute",
marginLeft: "330px",
marginBottom: "-35px",
borderRadius: "10px"
},

table: {
flexDirection: 'row',
alignItems: 'flex-start',
marginBottom: 10,
borderWidth: 2,
borderColor: '#ccc',
padding: 10,
borderRadius: 8,
},

info: {
flexDirection: 'row',
alignItems: 'flex-start',
marginTop: 20,
borderWidth: 1,
borderColor: '#aaa',
padding: 10,
borderRadius: 3,
},

index: {
fontWeight: 'bold',
},

tableMultiple: {
borderWidth: 2,
borderColor: '#d97706',
backgroundColor: '#fff7ed',
},

multipleText: {
marginTop: 4,
fontSize: 9,
fontWeight: 'bold',
color: '#92400e',
},

});


const LegajoVirtual = ({ cadete }) => {

const Usuario = ObtieneDatosCookies()

const [feriados, SetFeriados] = useState(null);

const [showGuardias, setShowGuardias] = useState(false);
const [showAsistencias, setShowAsistencias] = useState(false);
const [showPasesDeSalidas, setShowPasesDeSalidas] = useState(false);
const [showAvisos, setShowAvisos] = useState(false);
const [showCarpetasMedicas, setShowCarpetasMedicas] = useState(false);
const [showCambioCondiciones, setShowCambioCondiciones] = useState(false);
const [showInasistencias, setshowInasistencias] = useState(false)
const [showSanciones, setshowSanciones] = useState(false)
const [showCondonaciones, setshowCondonaciones] = useState(false)
const [muestroTodoSancion, setMuestroTodoSancion] = useState(false)


useEffect(() => {

const obtenerFeriados = async () => {

try {

const response = await axios.post(
'https://wwwa.isepsantafe.net.ar/expedientes/devuelveFeriados'
);

SetFeriados(response.data);

} catch (error) {

console.error(
"Error al obtener los feriados:",
error
);

}

};

obtenerFeriados();

}, []);


// ============================================================
// INASISTENCIA ACTIVA
// ============================================================

const esInasistenciaActiva = (ausencia) => {

if (!ausencia) return false;

const estado = String(
ausencia.estado ?? ""
)
.trim()
.toLowerCase();

if (!estado) return true;

const estadosInactivos = [
"0",
"false",
"inactivo",
"inactiva",
"desactivada",
"condonada",
"anulada",
"anulado"
];

return !estadosInactivos.includes(
estado
);

};


// ============================================================
// CONDONACION NUEVA
// ============================================================

const esCondonacionNueva = (condona) => {

if (!condona) return false;

const observacion = String(
condona.observacion || ""
);

return /inasistencias\s+condonadas\s*:/i.test(
observacion
);

};


// ============================================================
// CONDONACIONES DEL SISTEMA VIEJO
// ============================================================

const devuelveCantidadCondonacionesViejas = (info) => {

try {

const condonaciones =
info?.condonas || [];

return condonaciones.reduce(
(total, condona) => {


// Solo condonaciones de inasistencias

if (
String(condona?.tipo || "")
.trim()
.toLowerCase() !== "inasistencias"
) {

return total;

}


// Sistema nuevo:
//
// Las ausencias ya fueron pasadas a Inactiva.
// No hay que descontarlas nuevamente.

if (esCondonacionNueva(condona)) {

return total;

}


// Sistema viejo:
//
// La cantidad sigue funcionando como crédito.

const cantidad =
Number(condona.cantidad);

return total +
(
Number.isFinite(cantidad)
? cantidad
: 0
);

}, 0);

} catch (error) {

console.error(
"Error calculando condonaciones viejas:",
error
);

return 0;

}

};


// ============================================================
// CANTIDAD DE INASISTENCIAS
// ============================================================

const devuelveCantidadInasistencias = (info) => {

try {

const ausencias =
info?.Ausencia || [];

const pases =
info?.PaseDeSalidas || [];


// ------------------------------------------------------------
// AUSENCIAS ACTIVAS
// ------------------------------------------------------------

const ausenciasActivas =
ausencias.filter(
esInasistenciaActiva
);


// ------------------------------------------------------------
// PASES VALIDOS
// ------------------------------------------------------------

const pasesValidos = pases

.filter(pase =>

[
"Permiso Especial",
"Servicio Externo",
"Franco de Honor"
].includes(pase.tipo)

&& pase.fechaHoraSalida
&& pase.fechaHoraRegreso

)

.map(pase => ({

salida:
new Date(
pase.fechaHoraSalida
),

regreso:
new Date(
pase.fechaHoraRegreso
)

}));


// ------------------------------------------------------------
// AUSENCIAS QUE QUEDAN LUEGO DE LOS PASES
// ------------------------------------------------------------

let inasistenciasAntesDeCondonar = 0;

ausenciasActivas.forEach(
ausencia => {

const fechaAusencia =
new Date(
ausencia.fecha
);

const cubiertaPorPase =
pasesValidos.some(
pase =>

fechaAusencia >= pase.salida
&&
fechaAusencia <= pase.regreso

);

if (!cubiertaPorPase) {

inasistenciasAntesDeCondonar++;

}

});


// ------------------------------------------------------------
// CONDONACIONES VIEJAS
// ------------------------------------------------------------

const cantidadCondonacionesViejas =
devuelveCantidadCondonacionesViejas(
info
);


// ------------------------------------------------------------
// COMPUTABLES
// ------------------------------------------------------------

const inasistenciasComputables =
Math.max(

0,

inasistenciasAntesDeCondonar
-
cantidadCondonacionesViejas

);


return {

totalInasistencias:
ausenciasActivas.length,

inasistenciasAntesDeCondonar,

cantidadCondonacionesViejas,

inasistenciasComputables

};

} catch (error) {

console.error(
"Error calculando inasistencias:",
error
);

return {

totalInasistencias: 0,

inasistenciasAntesDeCondonar: 0,

cantidadCondonacionesViejas: 0,

inasistenciasComputables: 0

};

}

};


// ============================================================
// ASISTENCIAS
// ============================================================

const claveFechaAsistencia = (fecha) => {

if (!fecha) return "";

try {

return new Date(fecha)
.toLocaleDateString(
"en-CA",
{
timeZone:
"America/Argentina/Buenos_Aires"
}
);

} catch {

return String(fecha)
.split("T")[0];

}

};


const horaAsistencia = (fecha) => {

if (!fecha) return "-";

try {

return new Date(fecha)
.toLocaleTimeString(
"es-AR",
{
timeZone:
"America/Argentina/Buenos_Aires",
hour: "2-digit",
minute: "2-digit",
second: "2-digit",
hour12: false
}
);

} catch {

return "-";

}

};


const cantidadAsistenciasEnFecha = (
asistencias = [],
fecha
) => {

const clave =
claveFechaAsistencia(fecha);

return asistencias.filter(

(asistencia) =>
claveFechaAsistencia(
asistencia.fecha
) === clave

).length;

};


const obtenerDiasConMultiplesPresentes = (
asistencias = []
) => {

const conteo =
asistencias.reduce(
(acumulador, asistencia) => {

const clave =
claveFechaAsistencia(
asistencia.fecha
);

if (!clave)
return acumulador;

acumulador[clave] =
(acumulador[clave] || 0) + 1;

return acumulador;

}, {});


return Object.entries(conteo)

.filter(
([, cantidad]) =>
cantidad > 1
)

.map(
([fecha, cantidad]) => ({
fecha,
cantidad
})
);

};


// ============================================================
// PDF
// ============================================================

const CadetePDFDocument = ({ cadete }) => (

<Document>

<Page
size="A4"
style={styles.page}
wrap
>

<Text style={styles.sectionTitle}>
Cadete: {cadete.cadeteApellido}, {cadete.cadeteNombre}
</Text>


<View style={styles.fieldGroup}>

{cadete.fotoCadete && (

<Image
src={`https://wwwa.isepsantafe.net.ar/imagenes/${cadete.fotoCadete}`}
style={styles.photo}
/>

)}


<Image
style={{
width: "35px",
position: "absolute",
marginLeft: "480px",
marginTop: "-50px"
}}
src={logoIseP}
/>


<Text>

<Text style={styles.label}>
DNI:
</Text>

{" "}
{cadete.cadeteDni}

</Text>


<Text>

<Text style={styles.label}>
Sede Cursada:
</Text>

{" "}
{cadete.cadeteSede}

</Text>


<Text>

<Text style={styles.label}>
Promocion:
</Text>

{" "}
{cadete.Promocions[0].nombre}

</Text>


<Text>

<Text style={styles.label}>
Ultima Compañia:
</Text>

{" "}
{cadete.Seccion.Compania.nombre}

</Text>


<Text>

<Text style={styles.label}>
Condicion Actual:
</Text>

{" "}
{cadete.cadeteCondicion}

</Text>


<Text>

<Text style={styles.label}>
Edad a la fecha:
</Text>

{" "}
{devolvemeLaEdad(
cadete.fechaNacimiento
)} años

</Text>


<Text>

<Text style={styles.label}>
Ciudad:
</Text>

{" "}
{
cadete.cadeteCiudad
+
" ("
+
cadete.cadeteUR
+
")"
}

</Text>


<Text>

<Text style={styles.label}>
Correo electronico:
</Text>

{" "}
{cadete.cadeteEmail}

</Text>


<Text>

<Text style={styles.label}>
Telefono:
</Text>

{" "}
{cadete.cadeteCelular}

</Text>


<View style={styles.info}>

<View>

<Text>
Resumen de Información:
</Text>


{/* ====================================================== */}
{/* GUARDIAS RESUMEN */}
{/* ====================================================== */}

{cadete.Guardias?.length > 0 ? (

(() => {

const hoy =
new Date();

hoy.setHours(
0,
0,
0,
0
);

const guardiasPasadas =
cadete.Guardias.filter(
g => {

const fecha =
new Date(
g.fechaGuardia
);

fecha.setHours(
0,
0,
0,
0
);

return fecha <= hoy;

}
);

const cantidadGuardias =
guardiasPasadas.length;


return (

<>

<View>

<Text>

<Text style={styles.label}>
Cantidad de Guardias hasta la fecha programadas:
</Text>

{" "}
{cantidadGuardias}

</Text>

</View>

</>

);

})()

) : (

<Text>
Cantidad de Guardias:-
</Text>

)}


{/* ====================================================== */}
{/* ASISTENCIAS RESUMEN */}
{/* ====================================================== */}

{cadete.Asistencias?.length > 0 ? (

<>

<View>

<Text>

<Text style={styles.label}>
Marco Qr:
</Text>

{" "}
{cadete.Asistencias?.length} veces

</Text>

</View>


{obtenerDiasConMultiplesPresentes(
cadete.Asistencias
).length > 0 && (

<View>

<Text>

<Text style={styles.label}>
Fechas con mas de un presente:
</Text>

{" "}

{
obtenerDiasConMultiplesPresentes(
cadete.Asistencias
)

.map(
(item) =>
`${item.fecha} (${item.cantidad} marcas)`
)

.join(" - ")
}

</Text>

</View>

)}

</>

) : (

<Text></Text>

)}


{/* ====================================================== */}
{/* INASISTENCIAS RESUMEN */}
{/* ====================================================== */}

{
cadete.Ausencia
?.filter(
esInasistenciaActiva
)
.length > 0
? (

(() => {

const resumenInasistencias =
devuelveCantidadInasistencias(
cadete
);

const ausenciasActivas =
cadete.Ausencia.filter(
esInasistenciaActiva
);

const total =
resumenInasistencias
.totalInasistencias;

const computables =
resumenInasistencias
.inasistenciasComputables;

const condonacionesViejas =
resumenInasistencias
.cantidadCondonacionesViejas;

const justificadas =
ausenciasActivas.filter(
a =>
a.justificada
?.toLowerCase() === "si"
).length;

const injustificadas =
total - justificadas;

const noComputablesPorPase =
Math.max(

0,

total -
resumenInasistencias
.inasistenciasAntesDeCondonar

);


return (

<>

<View>

<Text>

<Text style={styles.label}>
Inasistencias Activas:
</Text>

{" "}
{total} días

{" "}
(
{justificadas} justificadas,
{" "}
{injustificadas} sin justificar,
{" "}
computables: {computables},
{" "}
{noComputablesPorPase} no computables por pase de salida,
{" "}
{condonacionesViejas} condonadas por sistema anterior
)

</Text>

</View>

</>

);

})()

) : (

<Text>
Inasistencias Activas:-
</Text>

)
}


{/* ====================================================== */}
{/* PASES RESUMEN */}
{/* ====================================================== */}

{cadete.PaseDeSalidas?.length > 0 ? (

<>

<View>

<Text>

<Text style={styles.label}>
Pases de Salida Totales:
</Text>

{" "}
{cadete.PaseDeSalidas?.length}

</Text>

</View>

</>

) : (

<Text></Text>

)}


{/* ====================================================== */}
{/* AVISOS RESUMEN */}
{/* ====================================================== */}

{cadete.excepciones?.length > 0 ? (

<>

<View>

<Text>

<Text style={styles.label}>
Avisos realizados:
</Text>

{" "}
{cadete.excepciones?.length}

</Text>

</View>

</>

) : (

<Text>
Avisos realizados:-
</Text>

)}


{/* ====================================================== */}
{/* CARPETAS MEDICAS RESUMEN */}
{/* ====================================================== */}

{cadete.CarpetaMedicas?.length > 0 ? (

(() => {

const carpetasFiltradas =
cadete.CarpetaMedicas.filter(
cm =>
cm.tipoDiagnostico !==
"Actividad Normal"
);

const cantidad =
carpetasFiltradas.length;


const diasTotales =
carpetasFiltradas.reduce(
(total, cm) => {

const inicio =
new Date(
cm.iniciaCondicion
);

const fin =
new Date(
cm.finalizaCondicion
);

const diffEnDias =
Math.ceil(
(fin - inicio)
/
(
1000 *
60 *
60 *
24
)
);

return total + diffEnDias;

}, 0);


return (

<>

<View>

<View>

<Text>

<Text style={styles.label}>
Carpetas Medicas Solicitadas:
</Text>

{" "}
{cadete.CarpetaMedicas.length}

<Text>
{" "}
(Cantidad con alguna limitacion de actividad: {cantidad}
</Text>

<Text>
{" "}
- Días totales con limitacion de actividad: {diasTotales})
</Text>

</Text>

</View>

</View>

</>

);

})()

) : (

<Text style={styles.label}>
Carpetas Médicas Solicitadas: -
</Text>

)}


{/* ====================================================== */}
{/* SANCIONES RESUMEN */}
{/* ====================================================== */}

{cadete.Sanciones?.length > 0 ? (

(() => {

const cantidadSanciones =
cadete.Sanciones.reduce(
(total, sancion) => {

if (
sancion.estado ==
"Finalizada"
) {

return total +
(
parseFloat(
sancion.cantidadConfirma
)
|| 0
);

}
else if (
sancion.estado ==
"Finalizada Reclamada"
) {

return total +
(
parseFloat(
sancion.cantidadResuelveRecurso
)
|| 0
);

}

return total;

}, 0);


const cantidadPliegos =
cadete.Sanciones.length;


return (

<View>

<Text>

<Text style={styles.label}>
Cantidad de Amonestaciones:
</Text>

{" "}
{cantidadSanciones}

{" "}
(
{
cantidadPliegos < 2
? cantidadPliegos + " pliego digital"
: cantidadPliegos + " pliegos digitales"
}
)

</Text>

</View>

);

})()

) : (

<Text style={styles.label}>
Cantidad de Amonestaciones firmes Totales: -
</Text>

)}


</View>

</View>

</View>


{/* ====================================================== */}
{/* GUARDIAS */}
{/* ====================================================== */}

{
cadete.Guardias?.length > 0
&&
showGuardias
? (

<>

<Text style={styles.sectionTitle}>
Guardias
</Text>


{cadete.Guardias.map(
(g, idx) => (

<View
key={idx}
style={styles.table}
>

<Text style={styles.index}>
{idx + 1}.
</Text>

<View>

<Text
style={{
fontSize: "6px",
position: "relative",
marginTop: "-10px"
}}
>

IdControl:{g.id}.

</Text>


<Text>

<Text style={styles.label}>
Fecha:
</Text>

{" "}
{
new Date(
g.fechaGuardia
)
.toLocaleDateString()
}

</Text>


<Text>

<Text style={styles.label}>
Tipo de Guardia:
</Text>

{" "}
{g.tipo}

</Text>

</View>

</View>

))}

</>

)
:
showGuardias
? (

<Text style={styles.sectionTitle}>
No registra Guardias
</Text>

)
:
<Text></Text>
}


{/* ====================================================== */}
{/* ASISTENCIAS */}
{/* ====================================================== */}

{
cadete.Asistencias?.length > 0
&&
showAsistencias
? (

<>

<Text style={styles.sectionTitle}>
Asistencias QR
</Text>


{cadete.Asistencias.map(
(a, idx) => {

const cantidadMismoDia =
cantidadAsistenciasEnFecha(

cadete.Asistencias,

a.fecha

);

const tieneMultiplesMarcas =
cantidadMismoDia > 1;


return (

<View

key={idx}

style={[

styles.table,

tieneMultiplesMarcas
? styles.tableMultiple
: {}

]}

>

<Text style={styles.index}>
{idx + 1}.
</Text>


<View>


<Text
style={{
fontSize: "6px",
position: "relative",
marginTop: "-10px"
}}
>

IdControl:{a.id}.

</Text>


<Text>

<Text style={styles.label}>
Fecha:
</Text>

{" "}

{
new Date(
a.fecha
)
.toLocaleDateString(
"es-AR",
{
timeZone:
"America/Argentina/Buenos_Aires"
}
)
}

</Text>


<Text>

<Text style={styles.label}>
Horario:
</Text>

{" "}

{
horaAsistencia(
a.fecha
)
}

</Text>


<Text>

<Text style={styles.label}>
Tipo:
</Text>

{" "}
{a.tipo}

</Text>


{a.estado && (

<Text>

<Text style={styles.label}>
Estado:
</Text>

{" "}
{a.estado}

</Text>

)}


{tieneMultiplesMarcas && (

<Text style={styles.multipleText}>

ATENCION: posee {cantidadMismoDia} presentes registrados en esta fecha.

</Text>

)}

</View>

</View>

);

}
)}

</>

)
:
showAsistencias
? (

<Text style={styles.sectionTitle}>
No registra Asistencias QR
</Text>

)
:
<Text></Text>
}


{/* ====================================================== */}
{/* INASISTENCIAS */}
{/* ====================================================== */}

{
cadete.Ausencia
?.filter(
esInasistenciaActiva
)
.length > 0
&&
showInasistencias
? (

<>

<Text style={styles.sectionTitle}>
Inasistencias
</Text>


{
cadete.Ausencia

.filter(
esInasistenciaActiva
)

.map(
(i, idx) => (

<View
key={idx}
style={styles.table}
>

<Text style={styles.index}>
{idx + 1}.
</Text>


<View>


<Text
style={{
fontSize: "6px",
position: "relative",
marginTop: "-10px"
}}
>

IdControl:{i.id}.

</Text>


<Text>

<Text style={styles.label}>
Fecha:
</Text>

{" "}

{
i.fecha
.split('-')
.reverse()
.join('-')
}

</Text>


<Text>

<Text style={styles.label}>
Tipo:
</Text>

{" "}
{i.tipo}

</Text>


<Text>

<Text style={styles.label}>
Justificada:
</Text>

{" "}
{i.justificada}

</Text>


{
i.observacion != ""
||
i.observacion
? (

<Text>

<Text style={styles.label}>
Observación:
</Text>

{" "}
{i.observacion}

</Text>

)
:
""
}


</View>

</View>

))
}

</>

)
:
showInasistencias
? (

<Text style={styles.sectionTitle}>
No registra Inasistencias
</Text>

)
:
<Text></Text>
}


{/* ====================================================== */}
{/* PASES DE SALIDA */}
{/* ====================================================== */}

{
cadete.PaseDeSalidas?.length > 0
&&
showPasesDeSalidas
? (

<>

<Text style={styles.sectionTitle}>
Pases de Salida
</Text>


{
cadete.PaseDeSalidas.map(
(s, idx) => (

<View
key={idx}
style={styles.table}
>

<Text style={styles.index}>
{idx + 1}.
</Text>


<View>


<Text
style={{
fontSize: "6px",
position: "relative",
marginTop: "-10px"
}}
>

IdControl:{s.id}.

</Text>


<Text>

<Text style={styles.label}>
Tipo:
</Text>

{" "}
{s.tipo}

</Text>


<Text>

<Text style={styles.label}>
Estado:
</Text>

{" "}
{s.estado}

</Text>


<Text>

<Text style={styles.label}>
Observacion:
</Text>

{s.observacion}

</Text>


<Text>

<Text style={styles.label}>
Estado:
</Text>

{s.estado}

</Text>


<Text>

<Text style={styles.label}>
Fecha Salida:
</Text>

{
new Date(
s.fechaHoraSalida
)
.toLocaleDateString()
}

</Text>


<Text>

<Text style={styles.label}>
Fecha Regreso:
</Text>

{
new Date(
s.fechaHoraRegreso
)
.toLocaleDateString()
}

</Text>


</View>

</View>

))
}

</>

)
:
showPasesDeSalidas
? (

<Text style={styles.sectionTitle}>
No registra Pases de Salida
</Text>

)
:
<Text></Text>
}


{/* ====================================================== */}
{/* AVISOS */}
{/* ====================================================== */}

{
cadete.excepciones?.length > 0
&&
showAvisos
? (

<>

<Text style={styles.sectionTitle}>
Avisos
</Text>


{
cadete.excepciones.map(
(av, idx) => (

<View
key={idx}
style={styles.table}
>

<Text style={styles.index}>
{idx + 1}.
</Text>


<View>


<Text
style={{
fontSize: "6px",
position: "relative",
marginTop: "-10px"
}}
>

IdControl:{av.id}.

</Text>


<Text>

<Text style={styles.label}>
Fecha:
</Text>

{" "}

{
new Date(
av.fecha
)
.toLocaleDateString()
}

</Text>


<Text>

<Text style={styles.label}>
Tipo:
</Text>

{" "}
{av.tipo}

</Text>


<Text>

<Text style={styles.label}>
Detalle:
</Text>

{" "}
{av.descripcion}

</Text>


</View>

</View>

))
}

</>

)
:
showAvisos
? (

<Text style={styles.sectionTitle}>
No registra Avisos
</Text>

)
:
<Text></Text>
}


{/* ====================================================== */}
{/* CARPETAS MEDICAS */}
{/* ====================================================== */}

{
cadete.CarpetaMedicas?.length > 0
&&
showCarpetasMedicas
? (

<>

<Text style={styles.sectionTitle}>
Carpetas Médicas
</Text>


{
cadete.CarpetaMedicas.map(
(cm, idx) => (

<View
key={idx}
style={styles.table}
>

<Text style={styles.index}>
{idx + 1}.
</Text>


<View>


<Text
style={{
fontSize: "6px",
position: "relative",
marginTop: "-10px"
}}
>

IdControl:{cm.id}.

</Text>


<Text>
Estado Carpeta: {cm.estado}
</Text>

<Text>
Motivo Solicitud: {cm.motivoSolicitud}
</Text>

<Text>
Usuario Recepciono: {cm.usuarioRecepciono}
</Text>

<Text>
Tipo Diagnóstico: {cm.tipoDiagnostico}
</Text>

<Text>
Diagnóstico o Recomendación : {cm.diagnostico}
</Text>

<Text>
Personal Sanidad: {cm.medicoReviso}
</Text>


<View>

<Text>
Solicitado: {
new Date(
cm.fechaSolicitud
)
.toLocaleString()
}
</Text>

<Text>
Revisado: {
new Date(
cm.updatedAt
)
.toLocaleString()
}
</Text>

<Text>
Inicio Condición: {
new Date(
cm.iniciaCondicion
)
.toLocaleString()
}
</Text>

<Text>
Finaliza Condición: {
new Date(
cm.finalizaCondicion
)
.toLocaleString()
}
</Text>

<Text>
Se aconsejo Pase de Salida: {
cm.otorgaPaseSalida
? "Si"
: "No"
}
</Text>

</View>


</View>

</View>

))
}

</>

)
:
showCarpetasMedicas
? (

<Text style={styles.sectionTitle}>
No registra Carpetas Médicas
</Text>

)
:
<Text></Text>
}


{/* ====================================================== */}
{/* SANCIONES */}
{/* ====================================================== */}

{
showSanciones
? (

<>

<>

{
muestroTodoSancion
? (

<>

<Text style={styles.sectionTitle}>
Sanciones(todos los pliegos)
</Text>


{
cadete.Sanciones.map(
(s, idx) => (

<View
key={idx}
style={styles.table}
>

<Text style={styles.index}>
{idx + 1}.
</Text>


<View>


<Text
style={{
fontSize: "6px",
position: "relative",
marginTop: "-10px"
}}
>

IdControl:{s.id}.

</Text>


<Text>

<Text style={styles.label}>
Fecha Falta:
</Text>

{
new Date(
s.fechaFaltaCometida
)
.toLocaleDateString()
}

{"     "}

Estado: {s.estado}

</Text>


<Text>

<Text style={styles.label}>
Artículo:
</Text>

{" "}
{s.articulo}

</Text>


<Text>

<Text style={styles.label}>
Inciso:
</Text>

{" "}
{s.inciso}

</Text>


<Text>

<Text style={styles.label}>
Descripción de Falta:
</Text>

{" "}
{s.descripcionFalta}

</Text>


<Text>

<Text style={styles.label}>
Sede Sancionante:
</Text>

{" "}
{s.cadeteSede}

</Text>


<Text>

<Text style={styles.label}>
Cantidad:
</Text>

{" "}
{s.cantidad} {s.tipo}

</Text>


<Text>

<Text style={styles.label}>
Usuario Sanciona:
</Text>

{" "}
{s.usuarioSanciona}

</Text>


<Text>

<Text style={styles.label}>
Fecha Notificado:
</Text>

{
s.fechaNotificado
? new Date(
s.fechaNotificado
).toLocaleDateString()
: ""
}

</Text>


<Text>

<Text style={styles.label}>
¿Realizó descargo el cadete?:
</Text>

{
s.descargo
? (

<Text>

Si.

{" "}

<Text>
Descargo: {s.descargo}
</Text>

{" "}

<Text>
Fecha de Descargo: {
s.fechaHoraDescargo
? new Date(
s.fechaHoraDescargo
).toLocaleDateString()
: ""
}
</Text>

</Text>

)
:
<Text>No.</Text>
}

</Text>


<Text>

<Text style={styles.label}>
Cantidad Confirmada:
</Text>

{" "}
{s.cantidadConfirma}

</Text>


<Text>

<Text style={styles.label}>
Fecha Confirmación:
</Text>

{" "}

{
s.fechaConfirma
? new Date(
s.fechaConfirma
).toLocaleDateString()
: ""
}

</Text>


<Text>

<Text style={styles.label}>
Usuario Controla:
</Text>

{" "}
{s.usuarioControla}

</Text>


<Text>

<Text style={styles.label}>
Usuario Notifica Confirma:
</Text>

{" "}
{s.usuarioNotificaConfirma}

</Text>


<Text>

<Text style={styles.label}>
Fecha Notifica Confirmación:
</Text>

{" "}

{
s.fechaNotificadoConfirma
? new Date(
s.fechaNotificadoConfirma
).toLocaleDateString()
: ""
}

</Text>


{
s.recursa != null
? (

<>

<Text
style={{
color: "red",
fontSize: "15px"
}}
>

Presentó Reclamo por Sanción

</Text>


<Text>

<Text style={styles.label}>
Fecha Reclamo Sanción:
</Text>

{" "}

{
s.fechaRecursa
? new Date(
s.fechaRecursa
).toLocaleDateString()
: ""
}

</Text>


<Text>

<Text style={styles.label}>
Usuario Resolvió Reclamo:
</Text>

{" "}
{s.usuarioResuelveRecurso}

</Text>


<Text>

<Text style={styles.label}>
Resolviendo:
</Text>

{" "}
{s.resuelveRecurso}

</Text>


<Text>

<Text style={styles.label}>
Cantidad Final:
</Text>

{" "}
{s.cantidadResuelveRecurso}

</Text>


<Text>

<Text style={styles.label}>
Fecha Notificado Resolución Reclamo:
</Text>

{" "}

{
s.fechaNotificadoResuelve
? new Date(
s.fechaNotificadoResuelve
).toLocaleDateString()
: ""
}

</Text>

</>

)
:
<Text></Text>
}


</View>

</View>

))
}

</>

)
:
(

<>

<Text style={styles.sectionTitle}>
Sanciones
</Text>


{
cadete.Sanciones

.filter(
x =>
x.estado == "Finalizada"
)

.map(
(s, idx) => (

<View
key={idx}
style={styles.table}
>

<Text style={styles.index}>
{idx + 1}.
</Text>


<View>


<Text
style={{
fontSize: "6px",
position: "relative",
marginTop: "-10px"
}}
>

IdControl:{s.id}.

</Text>


<Text>

<Text style={styles.label}>
Fecha Falta:
</Text>

{
new Date(
s.fechaFaltaCometida
)
.toLocaleDateString()
}

{"     "}

Estado: {s.estado}

</Text>


<Text>

<Text style={styles.label}>
Artículo:
</Text>

{" "}
{s.articulo}

</Text>


<Text>

<Text style={styles.label}>
Inciso:
</Text>

{" "}
{s.inciso}

</Text>


<Text>

<Text style={styles.label}>
Descripción de Falta:
</Text>

{" "}
{s.descripcionFalta}

</Text>


<Text>

<Text style={styles.label}>
Sede Sancionante:
</Text>

{" "}
{s.cadeteSede}

</Text>


<Text>

<Text style={styles.label}>
Cantidad:
</Text>

{" "}
{s.cantidad} {s.tipo}

</Text>


<Text>

<Text style={styles.label}>
Usuario Sanciona:
</Text>

{" "}
{s.usuarioSanciona}

</Text>


<Text>

<Text style={styles.label}>
Fecha Notificado:
</Text>

{
s.fechaNotificado
? new Date(
s.fechaNotificado
).toLocaleDateString()
: ""
}

</Text>


<Text>

<Text style={styles.label}>
¿Realizó descargo el cadete?:
</Text>

{
s.descargo
? (

<Text>

Si.

{" "}

<Text>
Descargo: {s.descargo}
</Text>

{" "}

<Text>
Fecha de Descargo: {
s.fechaHoraDescargo
? new Date(
s.fechaHoraDescargo
).toLocaleDateString()
: ""
}
</Text>

</Text>

)
:
<Text>No.</Text>
}

</Text>


<Text>

<Text style={styles.label}>
Cantidad Confirmada:
</Text>

{" "}
{s.cantidadConfirma}

</Text>


<Text>

<Text style={styles.label}>
Fecha Confirmación:
</Text>

{" "}

{
s.fechaConfirma
? new Date(
s.fechaConfirma
).toLocaleDateString()
: ""
}

</Text>


<Text>

<Text style={styles.label}>
Usuario Controla:
</Text>

{" "}
{s.usuarioControla}

</Text>


<Text>

<Text style={styles.label}>
Usuario Notifica Confirma:
</Text>

{" "}
{s.usuarioNotificaConfirma}

</Text>


<Text>

<Text style={styles.label}>
Fecha Notifica Confirmación:
</Text>

{" "}

{
s.fechaNotificadoConfirma
? new Date(
s.fechaNotificadoConfirma
).toLocaleDateString()
: ""
}

</Text>


{
s.recursa != null
? (

<>

<Text
style={{
color: "red",
fontSize: "15px"
}}
>

Presentó Reclamo por Sanción

</Text>


<Text>

<Text style={styles.label}>
Fecha Reclamo Sanción:
</Text>

{" "}

{
s.fechaRecursa
? new Date(
s.fechaRecursa
).toLocaleDateString()
: ""
}

</Text>


<Text>

<Text style={styles.label}>
Usuario Resolvió Reclamo:
</Text>

{" "}
{s.usuarioResuelveRecurso}

</Text>


<Text>

<Text style={styles.label}>
Resolviendo:
</Text>

{" "}
{s.resuelveRecurso}

</Text>


<Text>

<Text style={styles.label}>
Cantidad Final:
</Text>

{" "}
{s.cantidadResuelveRecurso}

</Text>


<Text>

<Text style={styles.label}>
Fecha Notificado Resolución Reclamo:
</Text>

{" "}

{
s.fechaNotificadoResuelve
? new Date(
s.fechaNotificadoResuelve
).toLocaleDateString()
: ""
}

</Text>

</>

)
:
<Text></Text>
}


</View>

</View>

))
}

</>

)
}

</>

</>

)
:
showSanciones
? (

<Text style={styles.sectionTitle}>
No registra Sanciones
</Text>

)
:
<Text></Text>
}


{/* ====================================================== */}
{/* CONDONACIONES */}
{/* ====================================================== */}

{
cadete.condonas?.length > 0
&&
showCondonaciones
? (

<>

<Text style={styles.sectionTitle}>
Condonaciones
</Text>


{
cadete.condonas.map(
(s, idx) => (

<View
key={idx}
style={styles.table}
>

<Text style={styles.index}>
{idx + 1}.
</Text>


<View>


<Text
style={{
fontSize: "6px",
position: "relative",
marginTop: "-10px"
}}
>

IdControl:{s.id}.

</Text>


<Text>

<Text style={styles.label}>
Fecha:
</Text>

{" "}

{
new Date(
s.createdAt
)
.toLocaleDateString()
}

</Text>


<Text>

<Text style={styles.label}>
Tipo:
</Text>

{" "}
{s.tipo}

</Text>


<Text>

<Text style={styles.label}>
Observacion:
</Text>

{" "}
{s.observacion}

</Text>


</View>

</View>

))
}

</>

)
:
showCondonaciones
? (

<Text style={styles.sectionTitle}>
No registra Condonaciones de ningun tipo
</Text>

)
:
<Text></Text>
}


{/* ====================================================== */}
{/* CAMBIO CONDICIONES */}
{/* ====================================================== */}

{
cadete.CambioCondicions?.length > 0
&&
showCambioCondiciones
? (

<>

<Text style={styles.sectionTitle}>
Cambio de Condiciones
</Text>


{
cadete.CambioCondicions.map(
(s, idx) => (

<View
key={idx}
style={styles.table}
>

<Text style={styles.index}>
{idx + 1}.
</Text>


<View>


<Text
style={{
fontSize: "6px",
position: "relative",
marginTop: "-10px"
}}
>

IdControl:{s.id}.

</Text>


<Text>

<Text style={styles.label}>
Condicion Anterior:
</Text>

{" "}
{s.condicionAnterior}

</Text>


<Text>

<Text style={styles.label}>
Condicion Actual:
</Text>

{" "}
{s.condicionActual}

</Text>


<Text>

<Text style={styles.label}>
Descripcion:
</Text>

{" "}
{s.descripcion}

</Text>


<Text>

<Text style={styles.label}>
Resolucion:
</Text>

{" "}

{
s.resolucion
+
" de fecha: "
+
(
s.fechaResolucion
? new Date(
s.fechaResolucion
).toLocaleDateString()
: ""
)
}

</Text>


</View>

</View>

))
}

</>

)
:
showCambioCondiciones
? (

<Text style={styles.sectionTitle}>
No registra Cambio de Condiciones
</Text>

)
:
<Text></Text>
}


{/* ====================================================== */}
{/* PIE */}
{/* ====================================================== */}

<View
style={{
flex: 1,
justifyContent: 'flex-end'
}}
>

<View
style={{
flexDirection: 'row',
justifyContent: 'space-between',
width: '100%'
}}
>

<Text
style={{
fontSize: "8px",
textAlign: "left"
}}
>

S.I.G.E.D.I ISeP

</Text>


<Text
style={{
fontSize: "8px",
textAlign: "right"
}}
>

{new Date().toLocaleDateString()}
{" "}
{new Date().toLocaleTimeString()}

</Text>

</View>

</View>


</Page>

</Document>

);


// ============================================================
// PANTALLA
// ============================================================

return (

<>

<div
style={{
display: 'flex',
flexDirection: 'column',
gap: 20,
width: '100%',
alignItems: 'center'
}}
>

<div

className="d-flex flex-wrap p-3 justify-content-center"

style={{
maxWidth: '400px',
gap: '10px',
}}

>


{/* ====================================================== */}
{/* GUARDIAS */}
{/* ====================================================== */}

<label className="btn btn-outline-primary">

<input

type="checkbox"

checked={showGuardias}

onChange={() =>
setShowGuardias(
!showGuardias
)
}

className="me-2"

/>

Incluir Guardias

</label>


{/* ====================================================== */}
{/* ASISTENCIAS */}
{/* ====================================================== */}

<label className="btn btn-outline-success">

<input

type="checkbox"

checked={showAsistencias}

onChange={() =>
setShowAsistencias(
!showAsistencias
)
}

className="me-2"

/>

Asistencias

</label>


{/* ====================================================== */}
{/* INASISTENCIAS */}
{/* ====================================================== */}

<label className="btn btn-outline-warning">

<input

type="checkbox"

checked={showInasistencias}

onChange={() =>
setshowInasistencias(
!showInasistencias
)
}

className="me-2"

/>

Inasistencias

</label>


{/* ====================================================== */}
{/* PASES */}
{/* ====================================================== */}

<label className="btn btn-outline-info">

<input

type="checkbox"

checked={showPasesDeSalidas}

onChange={() =>
setShowPasesDeSalidas(
!showPasesDeSalidas
)
}

className="me-2"

/>

Pases de Salida

</label>


{/* ====================================================== */}
{/* AVISOS */}
{/* ====================================================== */}

<label className="btn btn-outline-danger">

<input

type="checkbox"

checked={showAvisos}

onChange={() =>
setShowAvisos(
!showAvisos
)
}

className="me-2"

/>

Avisos

</label>


{/* ====================================================== */}
{/* CARPETAS MEDICAS */}
{/* ====================================================== */}

{
Usuario.destino == 7
||
Usuario.destino == 20
||
comprueboPermisos(
Usuario.funcion,
"veo datos sanidad"
)
? (

<>

<label className="btn btn-outline-secondary">

<input

type="checkbox"

checked={showCarpetasMedicas}

onChange={() =>
setShowCarpetasMedicas(
!showCarpetasMedicas
)
}

className="me-2"

/>

Carpetas Médicas

</label>

</>

)
:
""
}


{/* ====================================================== */}
{/* SANCIONES */}
{/* ====================================================== */}

<label className="btn btn-outline-dark">

<input

type="checkbox"

checked={showSanciones}

onChange={() =>
setshowSanciones(
!showSanciones
)
}

className="me-2"

/>

Sanciones


{
showSanciones
&&
comprueboPermisos(
Usuario.funcion,
"Elijo Ver Sanciones Legajo Virtual"
)
? (

<>

<h5>

Ver todas

{" "}

<input

type="checkbox"

checked={muestroTodoSancion}

onChange={() =>
setMuestroTodoSancion(
!muestroTodoSancion
)
}

/>

</h5>

</>

)
:
""
}

</label>


{/* ====================================================== */}
{/* CAMBIO CONDICIONES */}
{/* ====================================================== */}

<label className="btn btn-outline-primary">

<input

type="checkbox"

checked={showCambioCondiciones}

onChange={() =>
setShowCambioCondiciones(
!showCambioCondiciones
)
}

className="me-2"

/>

Cambio de Condiciones

</label>


{/* ====================================================== */}
{/* CONDONACIONES */}
{/* ====================================================== */}

<label className="btn btn-outline-primary">

<input

type="checkbox"

checked={showCondonaciones}

onChange={() =>
setshowCondonaciones(
!showCondonaciones
)
}

className="me-2"

/>

Condonaciones

</label>


{/* ====================================================== */}
{/* TODO */}
{/* ====================================================== */}

<label className="btn btn-outline-dark">

<input

type="checkbox"

checked={

showGuardias
&&
showAsistencias
&&
showInasistencias
&&
showPasesDeSalidas
&&
showAvisos
&&
showCarpetasMedicas
&&
showSanciones
&&
showCambioCondiciones
&&
showCondonaciones

}

onChange={() => {

const allSelected = !(

showGuardias
&&
showAsistencias
&&
showInasistencias
&&
showPasesDeSalidas
&&
showAvisos
&&
showCarpetasMedicas
&&
showSanciones
&&
showCambioCondiciones
&&
showCondonaciones

);

setShowGuardias(
allSelected
);

setShowAsistencias(
allSelected
);

setshowInasistencias(
allSelected
);

setShowPasesDeSalidas(
allSelected
);

setShowAvisos(
allSelected
);

setShowCarpetasMedicas(
allSelected
);

setshowSanciones(
allSelected
);

setShowCambioCondiciones(
allSelected
);

setshowCondonaciones(
allSelected
);

}}

className="me-2"

/>

Todo

</label>


{/* ====================================================== */}
{/* DESCARGAR PDF */}
{/* ====================================================== */}

<PDFDownloadLink

document={
<CadetePDFDocument
cadete={cadete}
/>
}

fileName={
`Legajo virtual ${cadete.cadeteApellido}_${cadete.cadeteDni}_${new Date()
.toISOString()
.replace(/[:.]/g, '-')
.replace('T', '_')
.slice(0, 16)}.pdf`
}

>

{({ loading }) => (

loading
? 'Generando PDF...'
: (

<>

<h4
style={{
textAlign: "center",
border: "1px solid black",
backgroundColor: "green",
color: "white"
}}
>

Descargar PDF del Cadete

</h4>

</>

)

)}

</PDFDownloadLink>


</div>

</div>


{/* ====================================================== */}
{/* VISOR PDF */}
{/* ====================================================== */}

<PDFViewer
showToolbar={false}
style={{
width: "100%",
height: "100vh"
}}
>

<CadetePDFDocument
cadete={cadete}
/>

</PDFViewer>

</>

);

};


export default LegajoVirtual;